/* angular:styles/component:css;53bdf4abd616755ab7d6d301c5ccc193220679b4e49765bf08da4ea60285cbbe;/opt/atlassian/pipelines/agent/build/src/app/tab-calculated-signals/tab-calculated-signals.page.ts */
ion-list-header {
  font-size: 1rem;
}
ion-item {
  --highlight-background: transparent !important;
}
ion-item div.label-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-grow: 1;
  align-items: center;
}
ion-item ion-button.rename-button {
  --padding-end: 8px;
  --padding-start: 12px;
  margin-left: auto;
}
ion-item ion-button.delete-button {
  --padding-end: 8px;
  --padding-start: 12px;
  margin-left: 0.5rem;
}
/*# sourceMappingURL=tab-calculated-signals.page.css.map */
